module.exports = __webpack_public_path__ + "static/img/a035.023d4a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a035.jpg
// module id = j6qT
// module chunks = 0